var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Pricing.QuotationClient"),
        width: "640px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view fcl-extra-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "primary" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "refresh" }, on: { click: _vm.refresh } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Refresh")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ClientName") } },
                      [
                        _c(
                          "el-select",
                          {
                            ref: "clientName",
                            attrs: {
                              no: "name",
                              "allow-create": true,
                              clearable: true,
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              "remote-method": _vm.similarClientFilter
                            },
                            on: { change: _vm.nameChange },
                            model: {
                              value: _vm.price.name,
                              callback: function($$v) {
                                _vm.$set(_vm.price, "name", $$v)
                              },
                              expression: "price.name"
                            }
                          },
                          _vm._l(_vm.similarClients, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: "[" + item.officeCode + "]" + item.name,
                                value: item
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Contact") } },
                      [
                        _c("el-input", {
                          ref: "contact",
                          attrs: { no: "contact", maxlength: 32 },
                          model: {
                            value: _vm.price.contact,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "contact", $$v)
                            },
                            expression: "price.contact"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Phone") } },
                      [
                        _c("el-input", {
                          ref: "phone",
                          attrs: { no: "phone", maxlength: 32 },
                          model: {
                            value: _vm.price.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "phone", $$v)
                            },
                            expression: "price.phone"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Fax") } },
                      [
                        _c("el-input", {
                          attrs: { no: "fax", maxlength: 32 },
                          model: {
                            value: _vm.price.fax,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "fax", $$v)
                            },
                            expression: "price.fax"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Email") } },
                      [
                        _c("el-input", {
                          attrs: { no: "email", maxlength: 64 },
                          model: {
                            value: _vm.price.email,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "email", $$v)
                            },
                            expression: "price.email"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Owner") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "ownerId",
                            "method-params": {
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.price.ownerId || ""
                          },
                          on: {
                            change: function(p) {
                              _vm.price.ownerId = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Address") } },
                      [
                        _c("el-input", {
                          attrs: { no: "address", type: "textarea" },
                          model: {
                            value: _vm.price.address,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "address", $$v)
                            },
                            expression: "price.address"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Remarks") } },
                      [
                        _c("el-input", {
                          attrs: { no: "remarks", type: "textarea" },
                          model: {
                            value: _vm.price.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "remarks", $$v)
                            },
                            expression: "price.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }